module.exports = __webpack_public_path__ + "img/presse_cafe.31ec5dd5.webp";